import { ContextMenuBankOperationsLink } from 'pages/Finance/BalanceReport/components/BalanceReportDatagridActions/ContextMenuBankOperationsLink';
import { ContextMenuCumulativeReportLink } from 'pages/Finance/BalanceReport/components/BalanceReportDatagridActions/ContextMenuCumulativeReportLink';
import { ContextMenuOrdersReportLink } from 'pages/Finance/BalanceReport/components/BalanceReportDatagridActions/ContextMenuOrdersReportLink';
import { ContextMenuRefundChargebackReportLink } from 'pages/Finance/BalanceReport/components/BalanceReportDatagridActions/ContextMenuRefundChargebackReportLink';
import { useBalanceReportContext } from 'pages/Finance/BalanceReport/context/BalanceReportContext';
import { Box } from 'shared/mui/Box';
import { Chip } from 'shared/mui/Chips';
import { ContextMenu } from 'shared/mui/ContextMenu';

import { BalanceRow } from './BalanceReportDatagrid';

type Props = {
  record: BalanceRow;
};

export const BalanceReportDatagridAccountNameField: React.FC<Props> = ({ record }) => {
  const { filters } = useBalanceReportContext();

  const { company, merchant, provider, merchantAccount } = record;
  return (
    <Box
      sx={{
        paddingLeft: `${record.level * 32}px`,
        display: 'flex',
        gap: '4px',
        alignItems: 'center',
      }}
    >
      {company && merchant && provider && merchantAccount && (
        <ContextMenu
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <ContextMenuOrdersReportLink
            appliedDate={filters.appliedDate}
            company={company}
            merchant={merchant}
            merchantAccount={merchantAccount}
            provider={provider}
            timezone={filters.timezone}
          />
          <ContextMenuRefundChargebackReportLink
            appliedDate={filters.appliedDate}
            company={company}
            merchant={merchant}
            merchantAccount={merchantAccount}
            provider={provider}
            timezone={filters.timezone}
          />
          <ContextMenuCumulativeReportLink
            appliedDate={filters.appliedDate}
            company={company}
            merchant={merchant}
            merchantAccount={merchantAccount}
            provider={provider}
            timezone={filters.timezone}
          />
          <ContextMenuBankOperationsLink
            appliedDate={filters.appliedDate}
            merchant={merchant}
            merchantAccount={merchantAccount}
            provider={provider}
            timezone={filters.timezone}
          />
        </ContextMenu>
      )}
      <Chip color="primary" label={record.name} sx={{ maxWidth: '230px' }} />
    </Box>
  );
};
